let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("h2MrD"), load("bYT2S"), load("dsiAd"), load("2WaJa")]).then(() => parcelRequire('eKgKX'));